import React, { PropsWithChildren, useState } from 'react';
import HeaderContext, { HeaderContextData } from './HeaderContext';

interface HeaderContextProviderProps extends PropsWithChildren {}
const HeaderContextProvider: React.FC<HeaderContextProviderProps> = ({ children }) => {
    const [value, setValue] = useState<HeaderContextData>({
        container: document.createElement('div'),
        isInProject: false,
        transparent: false,
        setTransparent: (flag) =>
            setValue((v) => {
                if (v.transparent !== flag) {
                    return { ...v, transparent: flag };
                }

                return v;
            }),
        hidden: false,
        setHidden: (flag) =>
            setValue((v) => {
                if (v.hidden !== flag) {
                    return { ...v, hidden: flag };
                }
                return v;
            }),
    });

    return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
};

export default HeaderContextProvider;
